var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$store.state.isReady)?_c('Page',{attrs:{"title":_vm.$t('Streams')}},[_c('LoadingLayout')],1):_c('router-view',{on:{"create":_vm.onCreate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }